import { useEditor } from '@toasttab/sites-components'
import * as React from 'react'
import { getImageUrl } from '../../Image'

export const GenericMenuComponent = ({
  editPath,
  styles
}: {
  editPath: string
  styles: React.CSSProperties
}) => {
  const { useEditableRef } = useEditor()
  const imageSrc = getImageUrl('admin/icons/blocks/menu_group.svg')

  const { editableRef } = useEditableRef<HTMLImageElement>({
    name: 'generic menu component',
    displayName: 'Generic Menu Component',
    actions: ['delete'],
    path: editPath,
    schema: {
      fields: []
    }
  })

  return (
    <img
      ref={editableRef}
      style={{ ...styles }}
      className='imagePlaceholder'
      src={imageSrc}
      alt='Generic Menu Component'
    />
  )
}
